import React, { Component } from "react";
import { Div, Image, Button, Text, Icon } from "atomize";
import { Transition } from "react-transition-group";
import WebsiteContainer from "./WebsiteContainer";
import CustomContainer from "./CustomContainer";
import AnimateLink from "./AnimateLink";

const duration = 300;

const defaultStyle = {
  transition: `height ${duration}ms ease-in-out`,
  height: 0,
};

export default class DesktopHeaderSubMenu extends Component {
  constructor(props) {
    super(props);

    this.state = {
      innerMenuHeight: 0,
      hoveredLinkSection: null,
    };

    this.innerMenu = React.createRef();
  }

  toggleHoverLinkSection = value => {
    this.setState({ hoveredLinkSection: value });
  };

  onEntering = () => {
    this.setState({ innerMenuHeight: this.innerMenu.current.clientHeight });
  };

  render() {
    const { innerMenuHeight, hoveredLinkSection } = this.state;
    const { desktopHeaderOpen, menu, linkName } = this.props;

    const transitionStyles = {
      entering: { height: "0" },
      entered: {
        height: `${desktopHeaderOpen === linkName && innerMenuHeight}px `,
      },
      exiting: { height: "0" },
      exited: { height: "0" },
    };

    return (
      <Transition
        in={desktopHeaderOpen}
        onEntering={this.onEntering}
        timeout={duration}
        unmountOnExit
        // nodeRef={this.submenuRef.current}
      >
        {state => (
          <Div
            style={{
              ...defaultStyle,
              ...transitionStyles[state],
            }}
            d="flex"
            pos="absolute"
            m={{ t: "-2px" }}
            bg="white"
            w="100vw"
            justify="space-between"
            overflow="hidden"
          >
            <Div
              pos="absolute"
              top="0"
              left="0"
              right="0"
              bg="primary700"
              d="flex"
              flexDir="column"
              ref={this.innerMenu}
              // p={{ x: "2.5rem", b: "2.5rem", t: "1rem" }}
            >
              <WebsiteContainer w="100%">
                <CustomContainer
                  p={
                    desktopHeaderOpen === "Solutions"
                      ? "1rem .5rem 2.5rem 1.5rem"
                      : "0 1.75rem 1.375rem"
                  }
                >
                  {menu &&
                    menu.map((link, index) => {
                      return (
                        <>
                          <Div
                            style={{
                              background:
                                link.title === hoveredLinkSection && "primary",
                            }}
                            transition
                            d="flex"
                            textAlign="center"
                            textColor="black"
                            fontFamily="secondary"
                            textColor="black"
                          >
                            <Div w="100%" m={{ l: "1.25rem" }}>
                              <Div
                                d="flex"
                                justify="space-between"
                                w="100%"
                                m={{ l: "-.75rem" }}
                              >
                                {link.menu.map((menuLink, index) => {
                                  return (
                                    <AnimateLink to={menuLink.link}>
                                      <Div
                                        minW="18rem"
                                        maxW="18rem"
                                        p={
                                          menuLink.image
                                            ? "1.875rem 0 1.125rem"
                                            : "1.2rem 0.75rem"
                                        }
                                        m={{ r: "1rem", t: "1.5rem" }}
                                        hoverBg="#FFCC56"
                                        textAlign="left"
                                        transition
                                        cursor="pointer"
                                        onMouseEnter={() =>
                                          this.toggleHoverLinkSection(
                                            link.title
                                          )
                                        }
                                        onMouseLeave={() =>
                                          this.toggleHoverLinkSection(null)
                                        }
                                        textColor="black"
                                      >
                                        <Div className="resources-header-images">
                                          {menuLink.image && (
                                            <Image
                                              className={`${menuLink.heading}`}
                                              src={menuLink.image}
                                              m="auto"
                                            />
                                          )}
                                        </Div>
                                        {menuLink.image ? (
                                          <Div
                                            textSize="subheader6"
                                            fontFamily="primary"
                                            m={{ t: "1.5rem" }}
                                            textWeight="800"
                                            textAlign="center"
                                            style={{ lineHeight: "1.625rem" }}
                                          >
                                            {menuLink.heading}
                                          </Div>
                                        ) : (
                                          <Div
                                            textSize="subheader5"
                                            fontFamily="secondary"
                                            m={{ b: "0.25rem" }}
                                            textWeight="700"
                                            style={{ lineHeight: "1rem" }}
                                          >
                                            {menuLink.heading}
                                          </Div>
                                        )}
                                        {menuLink.paragraph && (
                                          <Div d="flex" m={{ t: "0.5rem" }}>
                                            <Text
                                              fontFamily="secondary"
                                              textSize="caption1"
                                            >
                                              {menuLink.paragraph}
                                            </Text>
                                            <Icon
                                              name="RightArrow"
                                              size="0.75rem"
                                              m={{ t: "1px" }}
                                            />
                                          </Div>
                                        )}
                                      </Div>
                                    </AnimateLink>
                                  );
                                })}
                              </Div>
                            </Div>
                          </Div>
                        </>
                      );
                    })}
                </CustomContainer>
              </WebsiteContainer>
            </Div>
          </Div>
        )}
      </Transition>
    );
  }
}
